import Dialog from "@mui/material/Dialog";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import React from "react";
import useStore from "store/hook";
import { useChangeSubscriptionRequiredMutation } from "store/api/universities.api";
import { toast } from "react-toastify";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import CreditCardIcon from "@mui/icons-material/CreditCard";

const ChangeSubscriptionRequired = () => {
  const { store, setDialogue } = useStore();
  const logout = useLogout();

  const {
    app: {
      dialogs: {
        changeSubscriptionRequired: { isOpen, action, schoolID, name, subscription_required },
      },
    },
  } = store;

  const handleClose = () => {
    setDialogue({
      type: "changeSubscriptionRequired",
      isOpen: false,
      action: "",
      schoolID: "",
    });
  };

  const [changeSubscriptionRequired, { isLoading, error }] = useChangeSubscriptionRequiredMutation();

  const changeSubscriptionStatus = async () => {
    try {
      const response = await changeSubscriptionRequired({ school_id: schoolID }).unwrap();

      if (response?.status == 1) {
        toast.success(Formatmessage(response?.message) || "Subscription requirement updated successfully");
        handleClose();
      } else if (response?.status == 0) {
        toast.error(Formatmessage(response?.message));
      } else if (response?.status == 10) {
        logout();
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Server error. please try again in a few minutes.");
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "25px",
            m: {
              xs: 1,
              sm: 1,
              md: 2,
            },
          },
        }}
      >
        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "purple.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>

        <SoftBox
          width="100%"
          display="flex"
          flexDirection="column"
          sx={{
            overflowY: "scroll",
            backgroundColor: "white.main",
            "&::-webkit-scrollbar": { display: "none" },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <SoftBox
            display="flex"
            width="100%"
            flexDirection="column"
            gap={2}
            sx={{ p: { xs: 1, sm: 2, md: 2 } }}
          >
            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftBox
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "purple.light",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CreditCardIcon color="primary" sx={{ width: 40,
    height: 40, }} />
              </SoftBox>
            </SoftBox>

            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography sx={{ fontSize: 18 }} color="black" fontWeight="medium">
                Subscription Required
              </SoftTypography>
            </SoftBox>

            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography
                sx={{ fontSize: 16 }}
                align="center"
                color="lightblack"
                fontWeight="medium"
              >
                {subscription_required ? (
                  <>
                    Are you sure you want to deactivate the subscription for <SoftTypography component="span" fontWeight="bold" sx={{ fontSize: 16 }}>{name}</SoftTypography>? Once deactivated, users associated with this university will not need a subscription to access the app.
                  </>
                ) : (
                  <>
                    Are you sure you want to activate the subscription for <SoftTypography component="span" fontWeight="bold" sx={{ fontSize: 16 }}>{name}</SoftTypography>? Once activated, all users associated with this university will need to subscribe to access the app.
                  </>
                )}
              </SoftTypography>
            </SoftBox>

            <SoftBox
              width="100%"
              display="flex"
              gap={2}
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <SoftButton
                onClick={handleClose}
                color="dark"
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
                variant="outlined"
              >
                Cancel
              </SoftButton>

              <SoftButton
                onClick={changeSubscriptionStatus}
                disabled={isLoading}
                color="primary"
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
                variant="contained"
              >
                {isLoading ? "...Loading" : "Yes, Change"}
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "purple.main", mt: "auto" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>
      </Dialog>
    </React.Fragment>
  );
};

export default ChangeSubscriptionRequired;
